import { render, staticRenderFns } from "./AiTips.vue?vue&type=template&id=307b5909&scoped=true"
import script from "./AiTips.vue?vue&type=script&lang=js"
export * from "./AiTips.vue?vue&type=script&lang=js"
import style0 from "./AiTips.vue?vue&type=style&index=0&id=307b5909&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307b5909",
  null
  
)

export default component.exports